import Vue from 'vue'
import axios from 'axios'
import sha256 from 'sha256'
import { nSQL } from "@nano-sql/core"
import { Exchanger } from './exchanger'

const LOGIN_ERROR = 'Une erreur est survenue au cours de l\'identification. Veuillez s\'il-vous-plaît vérifier vos accès et réessayer.';
const LOGIN_URL = process.env.VUE_APP_COALISTE_LOGIN_URL;
const SALT = 'ls0K4Gt4CS3xBtJgzx6FPQDP99g0E9';

export const Auth = new Vue({

  methods: {
    user: function () {
      return this.isAuthenticated() ? JSON.parse(localStorage.getItem('auth_user')) : null;
    },

    isAuthenticated: function () {
      return '' !== (localStorage.getItem('auth_user') || '');
    },

    logout: function (context, redirect) {
      localStorage.setItem('auth_user', '');

      this.$emit('logged-out');

      if (redirect) {
        context.$router.replace(redirect);
      }
    },

    login: function (context, credentials, redirect) {
      if (Exchanger.isOffline()) {
        this.localLogin(context, credentials, redirect);
      } else {
        this.remoteLogin(context, credentials, redirect);
      }
    },

    hash: function (password) {
      return sha256(SALT + password);
    },

    setCurrentSolicitationAssignationId: async function (solicitationAssignationId) {
        return await nSQL('settings')
          .query("upsert", {
            name: 'users:' + this.user().id + ':current_solicitation_assignation_id',
            value: solicitationAssignationId
          })
          .exec()
          .then(function () {
            console.log('Current solicitation assignation id was set to ' + solicitationAssignationId + '.');
            this.$emit('current-solicitation-assignation-changed', solicitationAssignationId)
          }.bind(this));
    },

    getCurrentSolicitationAssignationId: async function () {
      const rows = await nSQL('settings')
        .query("select")
        .where(["name", "=", 'users:' + this.user().id + ':current_solicitation_assignation_id'])
        .exec();

      return rows.length === 0 ? null : parseInt(rows[0].value);
    },

    getCurrentSolicitationAssignation: async function () {
      const currentSolicitationAssignationId = await this.getCurrentSolicitationAssignationId();

      if (currentSolicitationAssignationId) {
        const rows = await nSQL('solicitation_assignations')
          .query("select")
          .where(["id", "=", currentSolicitationAssignationId])
          .exec();

        return rows.length === 0 ? null : rows[0];
      }
    },

    saveUser: function (user, password, callback) {
      const userRecord = Object.assign({}, user, {password: this.hash(password)});

      return nSQL('users')
        .query("upsert", userRecord)
        .exec()
    },

    remoteLogin: function (context, credentials, redirect) {
      axios.post(LOGIN_URL, credentials)
        .then(function (response) {
          if (response.status === 201) {
            let user = response.data.user;

            user.token = response.data.token;

            // Authenticate user
            localStorage.setItem('auth_user', JSON.stringify(user));
            localStorage.setItem('auth_mode', 'remote');

            console.log('Remote authentification');
            this.$emit('logged-in', {mode: 'remote'});

            this.saveUser(user, credentials.password)
              .then(function () {
                console.log('User data was locally saved.');
                if (redirect) {
                  context.$router.replace(redirect);
                }
              });
          }
        }.bind(this))
        .catch(function (error) {
          console.error(error);

          context.loginValid = false;
          context.error = LOGIN_ERROR;
        });
    },

    localLogin: function (context, credentials, redirect) {
      nSQL('users')
        .query("select")
        .where(["email", "=", credentials.email])
        .exec()
        .then(function (rows) {
          if (rows.length > 0 && rows[0].password === this.hash(credentials.password)) {
            let user = Object.assign({}, rows[0]);
            delete user.password;

            // Authenticate user
            localStorage.setItem('auth_user', JSON.stringify(user));
            localStorage.setItem('auth_mode', 'remote');

            console.log('Local authentification');
            this.$emit('logged-in', {mode: 'local'});

            if (redirect) {
              context.$router.replace(redirect);
            }
          } else {
            context.loginValid = false;
            context.error = LOGIN_ERROR;
          }
        }.bind(this))
        .catch(function (error) {
          console.error(error);
        });
    }
  }
});
